import { createSelector } from 'reselect';
import { creationContestsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const creationContestsYearsSelector = createSelector([creationContestsSelector], (creationContests) =>
  extractDatesFromNestedItems(
    [creationContests.content],
    [
      {
        type: 'range',
        startField: 'startDate',
        endField: 'endDate',
      },
    ],
  ),
);
